// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1uK1I","list":"PatternAutocomplete_list__2GOUD"};